// Informações institucionais e fixas da Talatona Kids

export const MISSION =
  'Promover uma educação com afeto, excelência e propósito, para o desenvolvimento global e integral das crianças, desde o Infantário ao Ensino Primário, através de uma abordagem moderna, inclusiva e inovadora, que valorize a identidade de cada criança e a prepare para fazer a diferença no mundo, com consciência e responsabilidade.';

export const VISION =
  'Ser uma referência nacional e internacional em Educação Infantil e Ensino Primário, reconhecida pela inovação pedagógica, pelo compromisso com o desenvolvimento humano e pela capacidade de transformar vidas através do conhecimento, da empatia e da inclusão.';

export const VALUES = [
  'Educação com propósito: ensino orientado para o cumprimento dos programas curriculares, ampliando sempre que necessário os seus objetivos, articulando o saber com o saber ser, desenvolvendo competências para a vida.',
  'Acolhimento humanizado e personalizado: promoção de um ambiente educativo seguro, afetivo e respeitoso, onde cada criança se sinta valorizada, escutada e parte de uma comunidade que cuida e educa com responsabilidade e intencionalidade.',
  'Valorização do crescimento individual e coletivo: estímulo à construção de um ambiente de convivência democrática, onde cada opinião é considerada e o diálogo é promovido como ferramenta de crescimento mútuo.',
  'Inovação: incentivo à curiosidade, ao pensamento crítico e ao uso de metodologias ativas, respeitando a diversidade de contextos socioculturais e promovendo uma postura investigativa e colaborativa.',
  'Educação transformadora: crença na aprendizagem como força motriz de transformação pessoal e social, capaz de impactar positivamente a vida das crianças, das suas famílias e da comunidade.'
];

export const EXTRA_ACTIVITIES = [
  {
    name: 'Ballet',
    description: 'Expressão corporal, disciplina e coordenação por meio da dança clássica.',
    image: 'https://cdn.pixabay.com/photo/2016/11/29/02/54/ballet-1869732_1280.jpg'
  },
  {
    name: 'Capoeira',
    description: 'Atividade cultural e esportiva que combina luta, dança e música.',
    image: 'https://cdn.pixabay.com/photo/2017/07/18/19/08/capoeira-2518587_1280.jpg'
  },
  {
    name: 'Jiu-jitsu',
    description: 'Arte marcial voltada para autodefesa, disciplina e controle corporal.',
    image: 'https://cdn.pixabay.com/photo/2017/09/12/22/24/martial-arts-2743545_1280.jpg'
  },
  {
    name: 'Futsal',
    description: 'Versão indoor do futebol que estimula agilidade, estratégia e espírito de equipe.',
    image: 'https://cdn.pixabay.com/photo/2016/11/29/04/17/soccer-1869946_1280.jpg'
  },
  {
    name: 'Instrumentos musicais',
    description: 'Desenvolvimento musical e cognitivo através de aulas práticas com diversos instrumentos.',
    image: 'https://cdn.pixabay.com/photo/2016/11/29/03/53/music-1869726_1280.jpg'
  }
];


export const AVAILABLE_CLASSES = {
  primary: [
    '1ª Classe',
    '2ª Classe',
    '3ª Classe',
    '4ª Classe',
    '5ª Classe',
    '6ª Classe'
  ],
  secondary: [
    '7ª Classe'
  ],
  kindergarten: [
    'Berçário',
    '1 ano',
    '2 anos',
    '3 anos',
    '4 anos',
    '5 anos'
  ]
};

export const CONTACTS = {
  secretary: ['Lívia Goulart', 'Hellen Ernesto'],
  email: 'secretaria@talatonakids.com',
  facebook: 'https://www.facebook.com/talatonakids',
  instagram: 'https://www.instagram.com/talatona_kids',
  phone: '+(244) 948 983 907',
  site: 'www.talatonakids.ao',
  address: 'Rua Pedro de Castro Van-Dúnem Loy Nº10, Condomínio Zeus, Belas.',
  maps: 'https://maps.google.com/maps?q=-8.9130687713623,13.1769666671753&output=embed'
}; 